export default __webpack_public_path__ + "static/worksans-semibolditalic-webfont-7973da9b40419bf0086a5bea10dbe6eb.woff";